import React, { useState } from "react";
import { Company } from "../types";

interface CompanySelectorProps {
  companies: Company[];
  onCompanySelect: (company: Company) => void;
  onCompanySearch: (query: string) => void;
  loading: boolean;
  searchQuery: string;
}

const CompanySelector: React.FC<CompanySelectorProps> = ({
  companies,
  onCompanySelect,
  onCompanySearch,
  loading,
  searchQuery,
}) => {
  const [inputValue, setInputValue] = useState(searchQuery);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSearchClick = () => {
    onCompanySearch(inputValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchClick();
    }
  };

  return (
    <div className="company-selector">
      <div className="search-welcome">
        <h2>📊 財務分析システム</h2>
        <p>企業名や証券コードで検索してください</p>
      </div>

      <div className="search-section">
        <h2>企業検索・選択</h2>
        <div className="search-input">
          <input
            type="text"
            placeholder="企業名または証券コードで検索（例：トヨタ、7678）"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            disabled={loading}
          />
          <button
            onClick={handleSearchClick}
            disabled={loading || !inputValue.trim()}
            className="search-button">
            {loading ? "検索中..." : "検索"}
          </button>
        </div>
        {companies.length > 0 && (
          <p className="results-count">{companies.length}社が見つかりました</p>
        )}
      </div>

      <div className="results-section">
        <div className="companies-grid">
          {companies.map(company => (
            <div key={company.security_code} className="company-card">
              <div className="company-header">
                <h3 className="company-name">{company.company_name}</h3>
                <span className="security-code">
                  証券コード: {company.security_code}
                </span>
              </div>
              {company.filing_dates.length > 1 ? (
                <div className="filing-dates">
                  <p>決算年度: {company.available_years.join(", ")}年</p>
                  <p className="latest-filing">
                    最新決算日: {company.latest_filing_date}
                  </p>
                </div>
              ) : (
                <p className="filing-date">
                  決算日: {company.latest_filing_date}
                </p>
              )}

              <div className="company-actions">
                <button
                  onClick={() => onCompanySelect(company)}
                  className="detail-btn"
                  disabled={loading}>
                  財務分析を見る
                </button>
              </div>
            </div>
          ))}
        </div>

        {companies.length === 0 && !loading && searchQuery && (
          <div className="no-results">
            <p>「{searchQuery}」に該当する企業が見つかりませんでした。</p>
            <p>検索条件を変更してください。</p>
          </div>
        )}

        {companies.length === 0 && !loading && !searchQuery && (
          <div className="search-instructions">
            <h3>🔍 使い方</h3>
            <ul>
              <li>上の検索ボックスに企業名や証券コードを入力してください</li>
              <li>例: 「トヨタ」「7203」</li>
              <li>企業名をクリックすると詳細な財務分析が表示されます</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanySelector;
